import { render, staticRenderFns } from "./LogopedistDetails.vue?vue&type=template&id=0fd34c85"
import script from "./LogopedistDetails.vue?vue&type=script&lang=js"
export * from "./LogopedistDetails.vue?vue&type=script&lang=js"
import style0 from "./LogopedistDetails.vue?vue&type=style&index=0&id=0fd34c85&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports